import React from "react";
import Modal from "react-bootstrap/Modal";

const CategoryModal = ({
  show,
  onClose,
  category,
  setCategory,
  categoryError,
  onSubmit,
  disableSubmit
}) => {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Add Unit</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="input-block local-forms">
          <label>
          Category Name <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            placeholder="Enter Category name"
          />

          {categoryError && (
            <div className="error text-danger mt-1">{categoryError}</div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={onSubmit}
          disabled={disableSubmit}
        >
          {disableSubmit ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CategoryModal;
